<!-- Header Section -->
@if (processPlan$ | async; as processPlan) {
  <div class="layout-col full">
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: processPlan }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: processPlan }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <ng-template #header let-plan>
      @if (creationMode) {
        <span>
          {{ 'process.plans.new' | translate }}
        </span>
      } @else {
        <elder-header [header]="plan.name" [subheader]="'ID: ' + plan.id"> </elder-header>
      }
    </ng-template>
    <elder-single-pane-wrapper class="flex">
      <elder-pane-header>
        <elder-pane-title>{{ 'process.plans.detail' | translate }}</elder-pane-title>
        <elder-pane-actions>
          <button
            mat-icon-button
            [disabled]="!mainFrm.form.valid"
            (click)="onSave($event)"
            matBadge="!"
            matBadgeColor="warn"
            [matBadgeHidden]="mainFrm.form.valid"
          >
            <mat-icon>save</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
              <mat-icon>delete</mat-icon>
              <span>{{ 'actions.delete' | translate }}</span>
            </button>
          </mat-menu>
        </elder-pane-actions>
      </elder-pane-header>
      <elder-pane-content class="p-0">
        <form #mainFrm="ngForm" class="layout-col full">
          <mat-tab-group class="full" animationDuration="0" elderTabGroupRouting="planDetailTab">
            <!-- Details -->
            <mat-tab label="{{ 'context.details' | translate }}">
              <div class="layout-col p-pane">
                <elder-pane-subtitle>{{
                  'context.identification' | translate
                }}</elder-pane-subtitle>
                <div class="flex-none layout-row gap-sm">
                  <mat-form-field class="flex">
                    <mat-label>{{ 'context.name' | translate }}</mat-label>
                    <input
                      matInput
                      name="name"
                      required
                      placeholder="{{ 'context.name' | translate }}"
                      [(ngModel)]="processPlan.name"
                    />
                  </mat-form-field>
                </div>
                <elder-pane-subtitle>{{ 'Matcher' | translate }}</elder-pane-subtitle>
                <app-work-item-matcher-detail class="flex" [matcher]="processPlan.workItemMatcher">
                </app-work-item-matcher-detail>
              </div>
            </mat-tab>
            <!-- Processing -->
            <mat-tab label="{{ 'processing.title' | translate }}">
              <div class="layout-col place-start-start">
                <div class="flex layout-col p-pane">
                  <elder-pane-subtitle>{{ 'processing.title' | translate }}</elder-pane-subtitle>
                  <p>{{ 'ProcessingType.title' | translate }}</p>
                  <div class="layout-row place-start-center gap-md">
                    <mat-form-field>
                      <elder-select
                        class="flex"
                        appProcessingTypeSelect
                        name="processing-type"
                        required
                        valueAsId
                        [(ngModel)]="processPlan.processingType"
                      >
                      </elder-select>
                    </mat-form-field>
                  </div>
                </div>
                @if (
                  processPlan.processingType && processPlan.preparationSpec;
                  as preparationSpec
                ) {
                  <div class="flex layout-col p-sm">
                    <elder-pane-subtitle>{{
                      'context.preparation' | translate
                    }}</elder-pane-subtitle>
                    <!-- TODO description -->
                    <p>
                      Berechnungen von Kürzungen oder Ausschuss, die beim Prozessstart ausgeführt
                      werden
                    </p>
                    <div class="layout-row place-start-center gap-md">
                      <mat-checkbox
                        name="preparation-enabled"
                        [disabled]="!consumptionAndFinishedSupported()"
                        [(ngModel)]="preparationSpec.enabled"
                        >{{ 'context.enabled' | translate }}
                      </mat-checkbox>
                    </div>
                  </div>
                }
              </div>
            </mat-tab>
            <!-- Operations -->
            <mat-tab label="{{ 'operations.title' | translate }}">
              <app-operation-segment-browser
                class="flex"
                [(operationSegmentSpecs)]="processPlan.operations"
                [materialMappingsEnabled]="
                  consumptionAndFinishedSupported() && !processPlan?.preparationSpec?.enabled
                "
                (onSave)="onSave($event)"
              >
              </app-operation-segment-browser>
            </mat-tab>
            <!-- Lead Time -->
            <mat-tab label="{{ 'processPlan.scheduling' | translate }}">
              <app-process-plan-scheduling
                [processLeadTimeSpec]="processPlan.processLeadTimeSpec"
                [releaseAt]="processPlan.releaseAt"
                (releaseAtChanged)="updateReleaseAt($event)"
              >
              </app-process-plan-scheduling>
            </mat-tab>
            <!-- Scrap -->
            <mat-tab
              label="{{ 'scrap.title' | translate }}"
              [disabled]="!consumptionAndFinishedSupported()"
            >
              <app-scrap-spec-browser [(scrapSpecs)]="processPlan.scrapSpecs">
              </app-scrap-spec-browser>
            </mat-tab>
            <!-- Packaging -->
            <mat-tab label="{{ 'packages.packaging' | translate }}">
              <div class="flex layout-col p-pane">
                <mat-slide-toggle
                  name="packagingEnabled"
                  [(ngModel)]="processPlan.packagingSpec.packagingEnabled"
                  [labelPosition]="'before'"
                >
                  <elder-pane-subtitle>{{ 'packaging.process' | translate }}</elder-pane-subtitle>
                </mat-slide-toggle>
                <div class="layout-row place-start-start gap-md my-md">
                  <!-- Supported Types -->
                  <mat-form-field subscriptSizing="dynamic">
                    <mat-label> {{ 'packaging.supported' | translate }}</mat-label>
                    <mat-select
                      #packageTypeSelect
                      multiple
                      [value]="supportedPackageTypes$ | async"
                      [compareWith]="compareFn"
                      (valueChange)="onSupportedPackageTypesChanged($event)"
                      [disabled]="disablePackagingInputs(processPlan)"
                    >
                      <mat-select-trigger>
                        {{ packageTypeSelect.value ? packageTypeSelect.value[0]?.name : '' }}
                        @if (packageTypeSelect.value?.length > 1) {
                          <span class="mat-caption">
                            (+{{ packageTypeSelect.value.length - 1 }}
                            {{
                              (packageTypeSelect.value?.length === 2
                                ? 'context.other_f'
                                : 'context.others'
                              ) | translate
                            }}
                            )
                          </span>
                        }
                      </mat-select-trigger>
                      @for (type of availablePackageTypes$ | async; track type) {
                        <mat-option [value]="type">
                          <div class="layout-row place-start-center gap-sm">
                            <span>{{ type.name }}</span>
                          </div>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <!-- Default Type -->
                  <mat-form-field subscriptSizing="dynamic">
                    <mat-label>{{ 'packaging.default' | translate }}</mat-label>
                    <mat-select
                      [(value)]="processPlan.packagingSpec.defaultPackageType"
                      [disabled]="disablePackagingInputs(processPlan)"
                    >
                      @for (type of supportedPackageTypes$ | async; track type) {
                        <mat-option [value]="type.id">
                          <div class="layout-row place-start-center gap-sm">
                            <span>{{ type.name }}</span>
                          </div>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-slide-toggle
                    [disabled]="disablePackagingInputs(processPlan)"
                    name="packageCalculationPossible"
                    [(ngModel)]="processPlan.packagingSpec.packageCalculationPossible"
                  >
                    {{ 'packages.autoCalculationEnabled' | translate }}
                  </mat-slide-toggle>
                </div>
              </div>
            </mat-tab>
            <!-- Labeling -->
            <mat-tab label="{{ 'labeling.title' | translate }}">
              <div class="layout-col p-pane">
                <app-labeling-spec-detail class="flex" [labelingSpec]="processPlan?.labelingSpec">
                </app-labeling-spec-detail>
              </div>
            </mat-tab>
            <!-- Display Properties -->
            <mat-tab label="{{ 'products.properties.display' | translate }}">
              <app-display-property-browser
                class="flex"
                [(propertyConfig)]="processPlan.displayProperties"
              >
              </app-display-property-browser>
            </mat-tab>
          </mat-tab-group>
        </form>
      </elder-pane-content>
    </elder-single-pane-wrapper>
  </div>
}
